import type { KyInstance } from 'ky';

import { ensureError } from '@enterprise/core';
import type { OperationResultWithData } from '@enterprise/types';

import { Uri } from '#constants/uri';

import type { UpsertDepartmentRequest } from './types/upsert-department-request.type';

/**
 * Creates or updates a department.
 *
 * @param instance - Ky HTTP instance from the application store.
 * @param body - The department payload (omit `uid` to create).
 * @returns OperationResultWithData wrapping the uid of the upserted department.
 */
export const upsertDepartment = async (instance: KyInstance, body: UpsertDepartmentRequest) => {
  try {
    return await instance
      .post<OperationResultWithData<string>>(Uri.departments.base, {
        json: body,
      })
      .json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
